<template>
    <div class="headerTop">
        <div class="left">&lt;返回</div>
        <div class="right" @click="changeType">{{showType?'文本':'PDF'}}</div>
    </div>
</template>

<script>
export default {
    props:[],
    data(){
        return {
            right: '文本',
            showType: true
        }
    },
    created(){
        
    },
    methods:{
        changeType(){
            this.showType = !this.showType;
        }
    }
}
</script>

<style>
    /* .headerTop{
        width: 100%;
        height: 44px;
        padding: 0 15px;
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        color: #333;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #eee;
    }
    .headerTop .left {
        padding-left: 20px;
        background: url(../assets/left.png) no-repeat left center;
        background-size: 10px 15px;
    }
    .headerTop .right{
        width: auto;
        padding: 0 10px;
        height: 30px;
        line-height: 30px;
        border-radius: 8px;
        background-color:bisque;
    } */
</style>



// WEBPACK FOOTER //
// src/components/headerTop.vue